import {
    DialogSize, Fancybox,
    RaikoBaseCardContainer,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoSectionContainer, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import FileManagerSelector from "../../../fileManager2/selector/FileManagerSelector";
import {FileManagerTypes} from "../../../../component/fileManager/FileManager";
import "../../../../raikoComponents/raikoEditor/internalImageSelector/InternalImageSelector.scss";
import thumbnail from "../../../../assets/images/uploadImage.svg"
import {LoadingHelper} from "../../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../../context/LoadingContext";

export default function PredefinedAvatar({service, predefinedAvatarId}) {

    const [selectedAvatarUrl, setSelectedAvatarUrl] = useState("");
    const [selectedAvatarImageId, setSelectedAvatarImageId] = useState(-1);
    const [galleryDialogOpenState, setGalleryDialogOpenState] = useState(false);
    const [actionButtonLoading, setActionButtonLoading] = useState(false);

    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof service !== "undefined") {
            getPredefinedAvatarFromServer()
        }
    }, []);


    function handleOpenFileManager() {
        setGalleryDialogOpenState(true)
    }


    function handleSelectPredefinedAvatar(id, url) {
        setSelectedAvatarImageId(id)
        setSelectedAvatarUrl(url)
    }


    function getPredefinedAvatarFromServer() {
        loading.show()
        service.getPredefinedAvatar(predefinedAvatarId)
            .then(response => {
                setSelectedAvatarUrl(response.url && response.url.downloadUrl ? response.url.downloadUrl : "")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdatePredefinedAvatar() {
        setActionButtonLoading(true)
        service.updatePredefinedAvatar(predefinedAvatarId, selectedAvatarImageId)
            .then(
                response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }


    return (
        <>
            <RaikoDefaultDialogPage
                onClose={_ => {
                    setGalleryDialogOpenState(false)
                }}
                open={galleryDialogOpenState}
                dialogSize={DialogSize.LARGE}
                pageTitle={"تصویر مورد نظر خود را انتخاب نمایید."}
            >
                <FileManagerSelector
                    setOpenDialog={setGalleryDialogOpenState}
                    bucketId={FileManagerTypes.PREDEFINED_AVATAR.id}
                    setSelectedFileUrl={handleSelectPredefinedAvatar}
                />

            </RaikoDefaultDialogPage>
            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"آواتار"}
                        actionButtonLoadingState={actionButtonLoading}
                        actionButtonTitle={selectedAvatarUrl ? "بروزرسانی" : "افزودن"}
                        hasActionButton
                        actionButtonOnclick={handleUpdatePredefinedAvatar}

                    >
                        <RaikoGridOneColumn>
                            <div
                                className={"baseSelectImageContainer"}
                                onClick={handleOpenFileManager}
                            >
                                {
                                    selectedAvatarUrl && selectedAvatarUrl.length > 0 ?
                                        <img src={selectedAvatarUrl} alt=""/> :
                                        <img src={thumbnail} alt=""/>

                                }
                                <span>
                                {
                                    selectedAvatarImageId && selectedAvatarImageId >= 0 ?
                                        "برای تغییر تصویر کلیک نمایید." :
                                        "برای انتخاب تصویر کلیک نمایید."
                                }
                            </span>
                            </div>
                        </RaikoGridOneColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>

            </RaikoGridOneColumn>
        </>

    )
}

// {
//     selectedAvatarUrl ? <div className={"imageViewerContainer"}>
//
//             <Fancybox
//                 options={{
//                     Carousel: {
//                         infinite: false,
//                     },
//                 }}
//             >
//                 <a href={selectedAvatarUrl} data-fancybox={"gallery"}>
//                     <img
//                         src={selectedAvatarUrl}
//                         alt={""}
//                     />
//                 </a>
//
//             </Fancybox>
//         </div> :
//         <div
//             className={"imageNotSelectedContainer"}
//             onClick={handleOpenFileManager}
//         >
//             <img src={thumbnail} alt=""/>
//             <span>برای انتخاب آواتار کلیک نمایید.</span>
//
//         </div>
// }